import * as React from "react";
import {
  PrismicPreviewProvider,
  componentResolverFromMap,
} from "gatsby-plugin-prismic-previews";

// Link Resolver
import { linkResolver } from "./src/components/utils/linkResolver";

// Pages
import Gallery from "./src/pages/gallery";
import Index from "./src/pages/index";
import Information from "./src/pages/information";

// Templates
import ContentPage from "./src/pages/{PrismicContentPage.url}";
import Project from "./src/pages/{PrismicProject.url}";

export const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
        linkResolver,
        componentResolver: componentResolverFromMap({
          gallery: Gallery,
          homepage: Index,
          information: Information,
          content_page: ContentPage,
          project: Project,
        }),
      },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
);
